"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartSummaryNotes = void 0;
const React = require("react");
const react_1 = require("react");
const SalesOrderContext_1 = require("../../../contexts/SalesOrderContext");
const SlimSection_1 = require("../../../../../../components/base/structure/SlimSection");
const TextInput_1 = require("../../../../../../components/base/inputs/TextInput");
const constants_1 = require("../../../helpers/constants");
const useConfig_1 = require("../../../../../../hooks/useConfig");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "CartSummaryNotes");
const CartSummaryNotes = ({}) => {
    const { theme } = (0, useConfig_1.useConfig)();
    const { notes, setNotes } = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext);
    return (React.createElement(SlimSection_1.SlimSection, { className: css("") },
        React.createElement(SlimSection_1.SlimSectionHeader, null,
            React.createElement(SlimSection_1.SlimSectionTitle, null, "Notes")),
        React.createElement(SlimSection_1.SlimSectionBody, null,
            React.createElement(TextInput_1.TextInput, { allowNewlines: true, onInputChange: setNotes, value: notes, className: css("notes"), placeholder: constants_1.text[theme].NotesPlaceholder }))));
};
exports.CartSummaryNotes = CartSummaryNotes;
//# sourceMappingURL=index.js.map